import {connect} from "react-redux";
import {ResearcherHeader} from "../views/ResearcherHeader";

const mapStateToProps = (state) => {
    return {
        users: state.users
    }
}

export const ResearchHeaderConnector = connect(mapStateToProps)(ResearcherHeader)